import { FC } from "react"
import { DefaultMoodIconSize } from "../../utils/constants"
import { MoodIconProps } from "../../utils/types"

const MoodHigherIcon: FC<MoodIconProps> = ({
  x,
  y,
  height = DefaultMoodIconSize,
  width = DefaultMoodIconSize,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      y={y}
      x={x}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.994 4.47963 15.5204 0.00597071 10 0ZM9.99935 18.3317C5.39698 18.3317 1.66602 14.6007 1.66602 9.99837C1.66602 5.396 5.39698 1.66504 9.99935 1.66504C14.6017 1.66504 18.3327 5.396 18.3327 9.99837C18.3276 14.5987 14.5996 18.3267 9.99935 18.3317ZM13.1431 12.0432C13.3946 11.6583 13.9103 11.5498 14.2956 11.8007C14.4816 11.9209 14.6122 12.1101 14.6585 12.3266C14.7048 12.5432 14.6629 12.7692 14.5423 12.9549C13.5431 14.4922 11.8341 15.4197 10.0006 15.4197C8.16714 15.4197 6.45811 14.4922 5.45894 12.9549C5.20719 12.5692 5.31576 12.0525 5.70144 11.8007C6.08712 11.549 6.60386 11.6576 6.85561 12.0432C7.54742 13.1071 8.73034 13.7489 9.99936 13.7489C11.2684 13.7489 12.4513 13.1071 13.1431 12.0432ZM7.08333 9.58171C7.54357 9.58171 7.91667 9.20861 7.91667 8.74837V6.24837C7.91667 5.78814 7.54357 5.41504 7.08333 5.41504C6.6231 5.41504 6.25 5.78814 6.25 6.24837V8.74837C6.25 9.20861 6.6231 9.58171 7.08333 9.58171ZM13.7507 8.74837C13.7507 9.20861 13.3776 9.58171 12.9173 9.58171C12.4571 9.58171 12.084 9.20861 12.084 8.74837V6.24837C12.084 5.78814 12.4571 5.41504 12.9173 5.41504C13.3776 5.41504 13.7507 5.78814 13.7507 6.24837V8.74837Z"
        fill="#424F80"
        fill-opacity="0.7"
      />
    </svg>
  )
}

export default MoodHigherIcon
